import { Clock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Btn } from "../components/kit";

export default function Pending() {
  const { user, logout, refresh } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="max-w-sm text-center space-y-4 fade-in" data-testid="pending-approval">
        <Clock className="w-10 h-10 mx-auto text-[#FF6B00]" />
        <h1 className="font-head text-3xl uppercase font-bold">
          {user.status === "pending" ? "Application received" : `Account ${user.status}`}
        </h1>
        <p className="text-neutral-400 text-sm">
          {user.status === "pending"
            ? "Driven Auto Care will review your application. You'll be able to see jobs once approved."
            : "Contact Driven Auto Care for details."}
        </p>
        <div className="flex gap-2 justify-center">
          <Btn variant="outline" onClick={refresh} data-testid="pending-refresh-btn">Check again</Btn>
          <Btn variant="ghost" onClick={logout} data-testid="pending-logout-btn">Log out</Btn>
        </div>
      </div>
    </div>
  );
}
